import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateDockCarrierActions as Actions,
  CreateDockCarrierRequestAction as RequestAction,
} from 'store/ducks/dockCarriers';

export function* createDockCarrierRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `dock-carriers`, postData);
    onSuccess && onSuccess();
    notify('success', 'Transportadora vinculada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
